<script setup>
  import { ref } from 'vue'
  import CountGraph from '@/components/Anonymization/CountGraph.vue'
  import TypeSlider from '@/components/Anonymization/TypeSlider.vue'
  import ProviderTable from '@/components/Anonymization/ProviderTable.vue'

  const providerTableRef = ref(null)

  const showCreateModal = () => {
    if (providerTableRef.value) {
      providerTableRef.value.showCreateModal()
    }
  }
</script>

<template>
  <div class="container-fluid providers-container">
    <div class="container providers-content">
      <CountGraph/>
      <TypeSlider class="mt-4"/>

      <div class="mt-5 mb-3 d-flex justify-content-between align-items-center">
        <h4>Providers</h4>
        <button class="btn btn-primary add-provider-btn" @click="showCreateModal">
          <i class="fas fa-plus me-2"></i>
          Add New Provider
        </button>
      </div>
      <ProviderTable ref="providerTableRef"/>
    </div>
  </div>
</template>

<style scoped>
.providers-container {
  padding-top: 2rem;
  padding-bottom: 2rem;
}


h4 {
  color: #FFFFFF;
  font-weight: 600;
  margin-bottom: 1rem;
}

.add-provider-btn {
  background-color: #7357D2;
  border: none;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  font-weight: 500;
  transition: background-color 0.2s;
}

.add-provider-btn:hover {
  background-color: #7F62E3;
}
</style>
